import * as v from 'valibot';
import { t } from 'i18next';
import { CustomField } from '~/api';

export const CustomFieldValueParamSchema = v.object({
	customFieldId: v.number(),
	customFieldListItemIds: v.nullable(v.array(v.number())),
	customFieldValue: v.nullable(v.string()),
});

export const makeCustomFieldValueSchema = (customField: CustomField) => {
	const { required, valueType } = customField;
	const ArrayIdSchema = v.array(v.number(), t('Vyberte možnost.'));

	switch (valueType) {
	case 'multiChoice':
		return v.object({
			customFieldListItemIds: required
				? v.pipe(ArrayIdSchema, v.minLength(1, t('Vyberte alespoň jednu možnost.')))
				: v.nullable(ArrayIdSchema),
			value: v.null(),
		});
	case 'list':
		return v.object({
			customFieldListItemIds: required
				? v.pipe(ArrayIdSchema, v.length(1, t('Vyberte možnost.')))
				: v.nullable(ArrayIdSchema),
			value: v.null(),
		});
	case 'text':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.pipe(v.string(t('Zadejte text.')), v.nonEmpty(t('Zadejte text.')))
				: v.nullable(v.string()),
		});
	case 'email':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.pipe(v.string(t('Zadejte e-mail.')), v.email(t('Zadejte e-mail.')))
				: v.nullable(v.string()),
		});
	case 'phone':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.pipe(v.string(t('Zadejte telefon.'))) // TODO: phone validation
				: v.nullable(v.string()),
		});
	case 'date':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.pipe(v.string(t('Zadejte datum.')), v.isoDate())
				: v.nullable(v.string()),
		});
	case 'checkbox':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.literal('1', t('Položka musí být vybrána.'))
				: v.picklist([ '0', '1' ]),
		});
	case 'number':
		return v.object({
			customFieldListItemIds: v.null(),
			value: required
				? v.pipe(v.string(t('Zadejte čislo.')), v.digits(t('Zadejte číslo.')))
				: v.nullable(v.string()),
		});
	default:
		return v.object({
			customFieldListItemIds: v.null(),
			value: v.null(),
		});
	}
};

export const makeCustomFieldsRequestSchema = (customFields: CustomField[]) => {
	const customFieldValue =
		v.variant('customFieldId', customFields.map((customField) => {
			return v.object({
				customFieldId: v.literal(customField.id),
				...makeCustomFieldValueSchema(customField).entries,
			});
		}));
	return v.array(customFieldValue);
};
